// Basic
import PropTypes from 'prop-types';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import RenderCompanyLongName from '../renders/RenderCompanyLongName';
import RenderAddress from '../renders/RenderAddress';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Separator } from '@/common-utils/components/ui/separator';
// Common
import ICONS from '@/common-utils/enums/icons';
import organizationFields from '../../fields/organizationFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
// Style
import '@/common-utils/components/renders/detailsGrid/DetailsGrid.scss';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.legalInfos
 * @param root0.showTitle
 * @param root0.className
 * @returns {JSX} LegalInfosPanel
 */
function LegalInfosPanel({ showTitle = true, legalInfos, className = '' }) {

    const organizationLegalInfosFields = {
        HEAD_OFFICE_REGISTRATION_NUMBER: organizationFields.LEGAL_INFOS.HEAD_OFFICE_REGISTRATION_NUMBER,
        REGISTRATION_NUMBER: organizationFields.LEGAL_INFOS.REGISTRATION_NUMBER,
        LEGAL_NATURE_LABEL: organizationFields.LEGAL_INFOS.LEGAL_NATURE_LABEL,
        BRANCH_BUSINESS_SECTOR_LABEL: organizationFields.LEGAL_INFOS.BRANCH_BUSINESS_SECTOR_LABEL,
        BUSINESS_NAME: organizationFields.LEGAL_INFOS.BUSINESS_NAME,
        CREATION_DATE: organizationFields.LEGAL_INFOS.CREATION_DATE,
        UPDATE_DATE: organizationFields.LEGAL_INFOS.UPDATE_DATE
    };

    const data = {
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.HEAD_OFFICE_REGISTRATION_NUMBER)]: legalInfos.headOfficeRegistrationNumber,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.REGISTRATION_NUMBER)]: legalInfos.registrationNumber,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.LEGAL_NATURE_LABEL)]: legalInfos.legalNatureLabel,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.BRANCH_BUSINESS_SECTOR_LABEL)]: legalInfos.branchBusinessSectorLabel,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.BUSINESS_NAME)]: legalInfos.businessName,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.CREATION_DATE)]: legalInfos.creationDate,
        [generateNestedFieldAccessor(organizationFields.LEGAL_INFOS.UPDATE_DATE)]: legalInfos.updateDate
    };

    return (
        <div className={className}>
            {showTitle && <Entity
                entity='details.legal_infos.title'
                namespace={nsOrganization}
                icon={ICONS.INFO}
            />}
            <div className='mb-4 text-center'>
                <Entity
                    className='italic font-extralight'
                    entity='details.legal_infos.disclaimer'
                    namespace={nsOrganization}
                />
            </div>
            <RenderCompanyLongName legalInfos={legalInfos} />
            <DetailsGrid
                data={data}
                fields={organizationLegalInfosFields} />
            <Separator className='my-4' />
            <RenderAddress legalInfos={legalInfos} />
        </div>
    );
}

LegalInfosPanel.propTypes = {
    showTitle: PropTypes.bool,
    legalInfos: PropTypes.object,
    className: PropTypes.string
};

export default LegalInfosPanel;